module.exports = __webpack_public_path__ + "static/media/fly0200.20afc449.webp";